/** 是否横屏 */
const isLandscape = () => {
    return window.orientation && [90, -90].includes(window.orientation)
}
let direction: any = false

/** 初始化缩放比例 */
export const initialScaleAdapter = () => {
    if (outerWidth > 640) return

    /** viewport 适配兼容方案
     * @description 需要按照 meta viewport 标准,定义设计稿尺寸
     */
    const resetScale = () => {
        const width = 375 * (isLandscape() ? 2 : 1)
        let initalScale = 1
        if (outerWidth) {
            initalScale = outerWidth / width
        } else {
            /** safari 在 ios11版本下, 存在无法获取outerWidth的bug, 所以这里单独增加一个处理, 解决safari浏览器正常缩放问题 */
            if (innerWidth === 750) {
                initalScale = 0.5
            } else if (innerWidth === 375) {
                initalScale = 1
            } else {
                // 听天由命 ~.~
                initalScale = 0
            }
        }
        if (window.orientation === undefined) {
            initalScale = 2
        }
        const meta: HTMLMetaElement = document.querySelector('meta[name=viewport]') as any
        const content = [
            `width=${width}`,
            `initial-scale=${initalScale.toFixed(2)}`,
            `minimum-scale=${initalScale.toFixed(2)}`,
            `maximum-scale=${initalScale.toFixed(2)}`,
            'viewport-fit=cover',
            'shrink-to-fit=no',
            'minimal-ui',
            'user-scalable=no'
        ].join(', ')
        console.log('meta:', content)
        if (meta) {
            meta.content = content
        } else {
            const tag = document.createElement('meta')
            tag.name = 'viewport'
            tag.content = content
            document.head.appendChild(tag)
        }
    }
    window.addEventListener('load', () => {
        resetScale()
        direction = isLandscape()
        window.addEventListener('resize', () => {
            if (direction !== isLandscape()) {
                location.reload()
            }
        })
    })
}
